import config from "config";
import Login from "components/Structure/Login/Login";
import { useContent } from "contexts/contentContext/contentContext";
import { useModal } from "contexts/modalContext/modalContext";
import { useUser } from "contexts/userContext/userContext";

const useGetStartedLoginCallback = () => {
  const { setModal } = useModal();
  const { getPath } = useContent();
  const { isLoggedIn } = useUser();

  const redirect = () => {
    window.location.href = config.baseurl + getPath() + "inbox?t=picker";
  };

  const handleClick = () => {
    isLoggedIn()
      ? redirect()
      : setModal({
          modal: Login,
          modalSize: "full-modal",
          props: {
            submitCallback: redirect,
          },
        });
  };

  return handleClick;
};

export default useGetStartedLoginCallback;
